import React from 'react'
import { BASELINE_H, ROW_H } from '../../lib/constants'

export interface BaselineBarProps {
  x: number
  width: number
  rowTop: number
  isMilestone: boolean
  /** Summary rows get a thin grey line instead of the bracket/rect used for tasks. Spec B §8.4. */
  isSummary?: boolean
}

const DIAMOND_HALF = 5
// Vertical offset of the baseline band below row centre. Was +6; the Task 11 review found the
// shifted (shiftUp) milestone diamond and this hollow baseline diamond overlapping by ~2px at
// ROW_H=32, so it was pushed to +9 (1px clearance), which still leaves the rect/diamond fully
// inside the 32px row (bottom at rowTop+30/+31).
const Y_OFFSET = 9

/** Grey baseline overlay drawn below the main bar when `showBaseline` is on. Spec B §8.4. */
const BaselineBar: React.FC<BaselineBarProps> = ({ x, width, rowTop, isMilestone, isSummary }) => {
  const y = rowTop + ROW_H / 2 + Y_OFFSET
  if (isMilestone) {
    const points = `${x},${y - DIAMOND_HALF} ${x + DIAMOND_HALF},${y} ${x},${y + DIAMOND_HALF} ${x - DIAMOND_HALF},${y}`
    return <polygon data-baseline points={points} className="fill-none stroke-muted-foreground" />
  }
  if (isSummary) {
    return <rect data-baseline x={x} y={y + (BASELINE_H - 2) / 2} width={Math.max(2, width)} height={2} className="fill-muted-foreground/60" />
  }
  return <rect data-baseline x={x} y={y} width={Math.max(2, width)} height={BASELINE_H} rx={2} className="fill-muted-foreground/60" />
}

export default BaselineBar
